/**
 *  Wrapper around a configuration string that can contain options.
 *  See DemoOptions for the format of options.
 */

import { DataTools } from './DataTools'

export class StringOptions
{
    private _value: string = "";
    private _options?: any;

    constructor(stringValue? : string)
    {
        if (stringValue)
            this.value = stringValue;
        else
            this.value = "";
    }

    get value(): string
    {
        return this._value;
    }

    set value(newValue: string)
    {
        this._value = newValue;
        this._options = DataTools.getOptions(newValue);
    }

    public toString(): string
    {
        return this._value;
    }

    /**
     * Check to see if the step_option field contains a given value.
     * This uses DataTools for option parsing so values can be an
     * array of text.  For example
     * hasOption("Align", true) === "left" or hasOption("Left")
     *
     * @param hasValue Option Text
     * @param valueAsSnake If true, the value is returned as a snake, example, "Left" returns "left"
     */
    checkOption(hasValue: string, valueAsSnake: boolean = false): boolean | any
    {
        if (!this._options)
            return false;

        // console.log("OPTIONS=", this._options);

        let key = DataTools.toSnakeString(hasValue);

        /* getOptions returned an object with key/value pair */
        if (typeof this._options === "object")
        {
            if (this._options[key])
            {
                return this._options[key];
            }
        }

        /* Return an array but better to check and then look for the key */
        if (this._options.length && this._options.length > 0)
        {
            for (let element of this._options)
            {
                if (DataTools.toSnakeString(element) === key) return true;
            }
        }

        return false;
    }

    Keys() : string[]
    {
		if (this._options.length && this._options.length > 0)
			return this._options.sort();

        if (typeof this._options === "object")
        {
            return Object.keys(this._options).sort();
		}

		return [ this._value ].sort();
    }

    /**
     * Helper function to check for a given option value, for example,
     * checkOptionValue("align", "center") will return true if the options
     * are align=center, "center", Align=Center, ["Center","Top"] etc.
    */
    checkValue(fieldName: string, fieldValue: string): boolean
    {
        const result = this.checkOption(fieldName, true);
        if (result === false) return false;
        if (result === DataTools.toSnakeString(fieldValue)) return true;
        return false;
    }

    /** Get the value of an option if set or return defaultValue if not.
    Example "Align" would be set to true by default.   "Align=Left" would return Left;
    */
    getValue(fieldName : string, defaultValue : any) : any
    {
		const result = this.checkOption(fieldName, true);
		if (result === false) return defaultValue;
		return result;
    }
}
